var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTutorialIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.845,
    height: 92.756,
    viewBox: "0 0 123.845 92.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    transform: "translate(-205.436 -5079.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    d: "M289.318 5089.94a34.085 34.085 0 0 1 .226 3.584c.209 6.072.794 17.428.794 17.428a.965.965 0 0 1-1.916.145l-4.574-17.076a20.57 20.57 0 0 1-.629-3.374v-.166a3.078 3.078 0 0 1 6.121-.421z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    d: "M309.681 5085.309a4.526 4.526 0 0 0-8.1-3.982l-.119.213a30.2 30.2 0 0 0-1.691 4.755l-6.785 25.094a1.418 1.418 0 0 0 2.543 1.229s7.638-14.874 11.855-22.751a50.507 50.507 0 0 0 2.355-4.725z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    d: "M323.93 5095.589a4.526 4.526 0 0 0-6.1-6.643l-.188.155a30.094 30.094 0 0 0-3.3 3.821l-15.411 20.933a1.417 1.417 0 0 0 1.925 2.066s12.506-11.1 19.289-16.914a50.51 50.51 0 0 0 3.906-3.551z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    d: "M326.74 5114.61a3.656 3.656 0 0 0-1.653-7.1l-.194.035a24.4 24.4 0 0 0-3.838 1.376l-19.159 8.6a1.145 1.145 0 0 0 .534 2.218s13.205-2.836 20.288-4.23a40.54 40.54 0 0 0 4.158-.944z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    fill: "#fff",
    fillRule: "evenodd",
    d: "M264.719 5119.073c-21.157-11.758-36.494 6.185-53 17.436 19.5 39.1 86.4 39.22 106 0-16.506-11.251-31.843-29.194-53-17.436z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    fill: "#041e42",
    fillRule: "evenodd",
    d: "M259.719 5124.073c-21.157-11.758-36.494 6.184-53 17.436 19.5 39.1 86.4 39.22 106 0-16.506-11.252-31.843-29.194-53-17.436zm0 28s-19.34.619-27.292-8.252l-.015-.017c8.643-3.479 17.894-7.808 27.308-4.6 9.494-3.2 18.6 1.11 27.309 4.6-7.943 8.896-27.31 8.274-27.31 8.274z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    d: "M259.732 5171.878h-.032c-24.031-.01-44.674-11.476-53.873-29.922l-.389-.781.72-.492c2.978-2.029 5.979-4.326 8.881-6.547 13.293-10.171 27.038-20.682 44.683-11.2 17.651-9.483 31.391 1.032 44.683 11.2 2.9 2.22 5.9 4.517 8.88 6.546l.722.492-.391.782c-9.228 18.459-29.873 29.922-53.884 29.922zm-51.723-30.042c9.048 17.31 28.762 28.032 51.69 28.042h.033c22.911 0 42.624-10.719 51.7-28.043-2.78-1.93-5.553-4.052-8.242-6.11-13.495-10.327-26.242-20.082-42.983-10.778l-.485.27-.486-.27c-16.744-9.3-29.487.451-42.982 10.778-2.691 2.058-5.465 4.175-8.245 6.111zm52.662 11.254c-.5 0-.824-.007-.951-.011-1.18.034-19.955.431-28.037-8.586l-.954-1.062 3.22-1.326c8.268-3.37 16.814-6.852 25.773-3.949 8.969-2.883 17.428.558 25.608 3.886q1.038.423 2.07.838l1.325.531-.951 1.064c-7.209 8.068-22.968 8.615-27.103 8.615zm-.951-2.012h.032c.179 0 17.425.458 25.508-6.906l-.684-.278c-7.937-3.23-16.144-6.569-24.537-3.739l-.321.109-.321-.109c-8.37-2.855-16.668.53-24.693 3.8l-.524.213c8.111 7.366 25.321 6.912 25.508 6.909z",
    className: "cls-1"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialIcon2);
export default __webpack_public_path__ + "static/media/tutorial-icon-2.80a4ec8e11760ae3df3d96c683669654.svg";
export { ForwardRef as ReactComponent };